import { UserButton } from "@clerk/clerk-react";
import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { AllRoutes } from "../config/routes";

const AdminBar: React.FC<{ title: string }> = ({ title }) => {
  return (
    <AppBar
      position="sticky"
      sx={{ backgroundColor: "#333", boxShadow: "none" }}
    >
      <Toolbar sx={{ gap: 2 }}>
        <Box
          component={RouterLink}
          to={AllRoutes.Home}
          sx={{
            display: "flex",
            alignItems: "center",
            lineHeight: 0,
          }}
        >
          <img
            src="/images/logo.png"
            alt="Home"
            style={{ height: "50px", verticalAlign: "middle" }}
          />
        </Box>
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}>
          {title}
        </Typography>
        <Button
          component={RouterLink}
          to={AllRoutes.Projects}
          color="inherit"
          sx={{ textTransform: "none" }}
        >
          Projects
        </Button>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <UserButton />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AdminBar;
